import React, { useState, useEffect } from "react";
import Header from "./Header";
import Aside from "./Aside";
import Footer from "./Footer";
import axios from '../../axios/axiosconf';

function AdministrarNotas() {
    const [notas, setNotas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [editando, setEditando] = useState(false);
    const [notaActual, setNotaActual] = useState({
        id: null,
        titulo: '',
        contenido: '',
        tipo: 'nota',
        color: 'info',
        fecha_recordatorio: '',
        completado: 0
    });

    let userdata = JSON.parse(localStorage.getItem('userdata'));

    useEffect(() => {
        cargarNotas();
    }, []);

    const cargarNotas = async () => {
        try {
            setLoading(true);
            // Cargar TODAS las notas (completadas y no completadas)
            const response = await axios.get(`/dashboard/notas?uid=${userdata.user_id}&activos=0`);
            setNotas(response.data);
            window.dispatchEvent(new CustomEvent('smile-notas-updated'));
        } catch (error) {
            console.error('Error al cargar notas:', error);
            alert('Error al cargar las notas');
        } finally {
            setLoading(false);
        }
    };

    const abrirModal = (nota = null) => {
        if (nota) {
            setEditando(true);
            setNotaActual(nota);
        } else {
            setEditando(false);
            setNotaActual({
                id: null,
                titulo: '',
                contenido: '',
                tipo: 'nota',
                color: 'info',
                fecha_recordatorio: '',
                completado: 0
            });
        }
        setShowModal(true);
    };

    const cerrarModal = () => {
        setShowModal(false);
        setEditando(false);
        setNotaActual({
            id: null,
            titulo: '',
            contenido: '',
            tipo: 'nota',
            color: 'info',
            fecha_recordatorio: '',
            completado: 0
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        try {
            if (editando) {
                await axios.put(`/dashboard/notas/${notaActual.id}?uid=${userdata.user_id}`, notaActual);
                alert('Nota actualizada exitosamente');
            } else {
                await axios.post(`/dashboard/notas?uid=${userdata.user_id}`, notaActual);
                alert('Nota creada exitosamente');
            }
            cerrarModal();
            cargarNotas();
        } catch (error) {
            console.error('Error al guardar nota:', error);
            alert('Error al guardar la nota');
        }
    };

    const eliminarNota = async (id) => {
        if (!window.confirm('¿Está seguro de eliminar esta nota?')) return;

        try {
            await axios.delete(`/dashboard/notas/${id}?uid=${userdata.user_id}`);
            alert('Nota eliminada exitosamente');
            cargarNotas();
        } catch (error) {
            console.error('Error al eliminar nota:', error);
            alert('Error al eliminar la nota');
        }
    };

    const toggleCompletado = async (nota) => {
        try {
            await axios.put(`/dashboard/notas/${nota.id}?uid=${userdata.user_id}`, {
                ...nota,
                completado: nota.completado ? 0 : 1
            });
            cargarNotas();
        } catch (error) {
            console.error('Error al actualizar estado:', error);
        }
    };

    const getColorClass = (color) => {
        const colores = {
            'info': 'admin-notas-card admin-notas-card--info',
            'warning': 'admin-notas-card admin-notas-card--warning',
            'danger': 'admin-notas-card admin-notas-card--danger',
            'success': 'admin-notas-card admin-notas-card--success',
            'primary': 'admin-notas-card admin-notas-card--primary'
        };
        return colores[color] || 'admin-notas-card admin-notas-card--info';
    };

    const getTipoIcon = (tipo) => {
        const iconos = {
            'nota': 'fas fa-sticky-note',
            'recordatorio': 'fas fa-bell',
            'importante': 'fas fa-exclamation-circle'
        };
        return iconos[tipo] || 'fas fa-sticky-note';
    };

    return (
        <div className="hold-transition">
            <Header />
            <Aside activelink="indicators" />

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0">Administrar Notas y Recordatorios</h1>
                            </div>
                            <div className="col-sm-6">
                                <button 
                                    className="btn btn-primary float-right"
                                    onClick={() => abrirModal()}
                                >
                                    <i className="fas fa-plus"></i> Nueva Nota
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">
                        {loading ? (
                            <div className="text-center">
                                <i className="fas fa-spinner fa-spin fa-3x"></i>
                            </div>
                        ) : (
                            <div className="row">
                                {notas.length === 0 ? (
                                    <div className="col-12">
                                        <div className="alert alert-info">
                                            No hay notas registradas. Crea tu primera nota.
                                        </div>
                                    </div>
                                ) : (
                                    notas.map(nota => (
                                        <div key={nota.id} className="col-md-4">
                                            <div className={`card border-0 ${getColorClass(nota.color)} ${nota.completado === 1 ? 'opacity-50' : ''}`}>
                                                <div className="card-header">
                                                    <h3 className="card-title">
                                                        <i className={getTipoIcon(nota.tipo)}></i> {nota.titulo}
                                                        {nota.completado === 1 && (
                                                            <span className="badge badge-success ml-2">
                                                                <i className="fas fa-check"></i> Completado
                                                            </span>
                                                        )}
                                                    </h3>
                                                    <div className="card-tools">
                                                        <button 
                                                            className="btn btn-tool"
                                                            onClick={() => abrirModal(nota)}
                                                        >
                                                            <i className="fas fa-edit"></i>
                                                        </button>
                                                        <button 
                                                            className="btn btn-tool"
                                                            onClick={() => eliminarNota(nota.id)}
                                                        >
                                                            <i className="fas fa-trash"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="card-body">
                                                    <p style={nota.completado === 1 ? {textDecoration: 'line-through'} : {}}>
                                                        {nota.contenido}
                                                    </p>
                                                    {nota.fecha_recordatorio && (
                                                        <p className="mb-0">
                                                            <small>
                                                                <i className="fas fa-calendar"></i> {nota.fecha_recordatorio}
                                                            </small>
                                                        </p>
                                                    )}
                                                    {nota.tipo === 'recordatorio' && (
                                                        <div className="custom-control custom-checkbox mt-2">
                                                            <input
                                                                type="checkbox"
                                                                className="custom-control-input"
                                                                id={`completado-${nota.id}`}
                                                                checked={nota.completado === 1}
                                                                onChange={() => toggleCompletado(nota)}
                                                            />
                                                            <label 
                                                                className="custom-control-label" 
                                                                htmlFor={`completado-${nota.id}`}
                                                            >
                                                                Completado
                                                            </label>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>
                        )}
                    </div>
                </section>
            </div>

            {/* Modal para crear/editar nota */}
            <div className={`modal fade ${showModal ? 'show' : ''}`} 
                 style={{ display: showModal ? 'block' : 'none' }}
                 tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <form onSubmit={handleSubmit}>
                            <div className="modal-header">
                                <h4 className="modal-title">
                                    {editando ? 'Editar Nota' : 'Nueva Nota'}
                                </h4>
                                <button type="button" className="close" onClick={cerrarModal}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="form-group">
                                    <label>Título *</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={notaActual.titulo}
                                        onChange={(e) => setNotaActual({...notaActual, titulo: e.target.value})}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Contenido *</label>
                                    <textarea
                                        className="form-control"
                                        rows="4"
                                        value={notaActual.contenido}
                                        onChange={(e) => setNotaActual({...notaActual, contenido: e.target.value})}
                                        required
                                    ></textarea>
                                </div>
                                <div className="form-group">
                                    <label>Tipo</label>
                                    <select
                                        className="form-control"
                                        value={notaActual.tipo}
                                        onChange={(e) => setNotaActual({...notaActual, tipo: e.target.value})}
                                    >
                                        <option value="nota">Nota</option>
                                        <option value="recordatorio">Recordatorio</option>
                                        <option value="importante">Importante</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label>Color</label>
                                    <select
                                        className="form-control"
                                        value={notaActual.color}
                                        onChange={(e) => setNotaActual({...notaActual, color: e.target.value})}
                                    >
                                        <option value="info">Azul (Info)</option>
                                        <option value="warning">Amarillo (Warning)</option>
                                        <option value="danger">Rojo (Danger)</option>
                                        <option value="success">Verde (Success)</option>
                                        <option value="primary">Azul Oscuro (Primary)</option>
                                    </select>
                                </div>
                                {notaActual.tipo === 'recordatorio' && (
                                    <div className="form-group">
                                        <label>Fecha de Recordatorio</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={notaActual.fecha_recordatorio}
                                            onChange={(e) => setNotaActual({...notaActual, fecha_recordatorio: e.target.value})}
                                        />
                                    </div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={cerrarModal}>
                                    Cancelar
                                </button>
                                <button type="submit" className="btn btn-primary">
                                    {editando ? 'Actualizar' : 'Crear'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {showModal && <div className="modal-backdrop fade show"></div>}

            <Footer showToast={false} delay={0} />
        </div>
    );
}

export default AdministrarNotas;
